// TODO: need to remove this hard code and use ENV file instead
const serverconfig = {
  // serverUrl: "https://localhost:7165",
  // serverUrl: 'http://localhost:5000',
  serverUrl: 'https://api.anatomagelessons.com'
};

export default serverconfig;
